import { render, staticRenderFns } from "./ManageFundingFile.vue?vue&type=template&id=822a8d28&scoped=true"
import script from "./ManageFundingFile.vue?vue&type=script&lang=ts"
export * from "./ManageFundingFile.vue?vue&type=script&lang=ts"
import style0 from "./ManageFundingFile.vue?vue&type=style&index=0&id=822a8d28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822a8d28",
  null
  
)

export default component.exports